export default {
  groupsOfCustomer: [],
  groupOfCustomerInfos: null,
  groupsOfCustomerResume: []
}
